import styled from 'styled-components'

import {
  Button,
  LoadingPlaceholder as BaseLoadingPlaceholder,
} from '@sketch/components'

export const InputWrapper = styled.div`
  display: flex;
  margin-bottom: 24px;
`

export const AddMemberButton = styled(Button)`
  margin-top: auto;
  margin-left: 16px;
`

export const LoadingPlaceholder = styled(BaseLoadingPlaceholder)`
  margin: auto;
`
